import { useState } from 'react';
import queryString from 'query-string';
import moment from 'moment-timezone';
import useStewardshipFilter from '@/pages/events/useStewardshipFilter';
import { PayloadStates } from '@lore/utils';
import { useConnect } from '@hooks/@lore/query-connect';

export default function useQuery(props) {
  const { location, PAGE_SIZE = 10, extra = {} } = props;

  const [timestamp] = useState(moment().toISOString());
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('event.find', {
    where: {
      eager: {
        $where: {
          activityId: {
            $null: false
          },
          completed: false,
          cancelled: false,
          // A resource is still active through the entirety of its date, so
          // "expired" ($lt, not $lte) only starts the day after - this needs
          // to stay the exact complement of the $gte used to decide a
          // resource is still active.
          date: {
            $lt: timestamp
          },
          $or: stewardshipFilter,
          ...extra
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: PAGE_SIZE,
      order: 'createdAt desc'
    },
    exclude: function (model) {
      return model.state === PayloadStates.DELETED;
    }
  }, {
    keepPreviousData: true
  });
}